import { render } from "./user-cp.vue?vue&type=template&id=4c05c134&scoped=true"
import script from "./user-cp.vue?vue&type=script&lang=js"
export * from "./user-cp.vue?vue&type=script&lang=js"

import "./user-cp.vue?vue&type=style&index=0&id=4c05c134&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c05c134"]])

export default __exports__